"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.join = void 0;

var _curry = require("../curry/curry");

var _join = function _join(separator, source) {
  return [].join.call(source, separator);
};
/**
 * Join all elements of an array into a string
 *
 * @tag Array
 * @signature (separator: String)(source: Array): String
 * @signature (separator: String, source: Array): String
 *
 * @param {String} separator Separator between each adjacent elements
 * @param {[]}     source    Source array
 *
 * @return {String}
 *
 * @example
 * join(",")(["lorem", "ipsum"])
 * // => "lorem,ipsum"
 */


var join = (0, _curry.curry)(_join);
exports.join = join;